import {
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
} from "@mui/material";
import theme from "../../../config/theme";
import { StyledBox } from "../../ledger/components/Welcome";
import { StyledButton } from "../../../components/common/Button";

const Successful = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container sx={{ display: "flex", justifyContent: "center" }}>
        <StyledBox style={{ marginTop: "8rem" }}>
          <Typography
            variant="h4"
            sx={{
              marginTop: "3.25rem",
              fontWeight: 600,
              fontSize: "1.875rem",
              color: "#0C9D46",
              letterSpacing: "0.015625rem",
            }}
          >
            Congratulations
          </Typography>
          <Typography
            variant="h6"
            sx={{
              marginTop: "1.25rem",
              fontWeight: 400,
              fontSize: "1.125rem",
              color: "#6A6A6A",
              letterSpacing: "0.009375rem",
            }}
          >
            Account Created Successfully!
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                marginTop: "3.75rem",
                width: "18rem",
                height: "10.625rem",
                backgroundColor: "#EEF6FF",
              }}
            ></Box>
          </Box>
          <StyledButton
            style={{
              backgroundColor: `${theme.palette.primary.main}`,
              height: "3rem",
              width: "21rem",
              marginTop: "1.25rem",
              borderRadius: "1.5rem",
              color: "#FFFFFF",
              letterSpacing: "0.078125rem",
            }}
          >
            LOGIN
          </StyledButton>
        </StyledBox>
      </Container>
    </ThemeProvider>
  );
};

export default Successful;
